/* eslint-disable max-lines */
import React from 'react';
import styles from '../help.scss';
import { StaticHTML } from '../../StaticHTML';
import HelmetComponent from "../../../utils/HelmetHelper";
const instructionsForUse = `
  <div>
    <p>
       <strong>1. VRSTA OGLASA</strong>
    </p>
    <p>
      Na Index Oglasniku nije dopušteno oglašavanje kupovine. Drugim riječima, dopušteno je isključivo oglašavanje prodaje.
    </p>

    <p>
       <br/>
       <strong>2. ŽIVOTINJE</strong>
    </p>
 
    <p>
       <strong>2.1. Psi</strong>
    </p>
    <p>
       Zabranjeno je prodavati životinje koje su još ovisne o majci ili koje se ne mogu samostalno hraniti te bolesne ili ozlijeđene životinje. Pri oglašavanju pasa u svrhu prodaje ili promjene vlasništva prodavač mora osigurati, a oglašivač mora objaviti broj mikročipa psa i broj mikročipa majke psa.
    </p>
    <p><a style="color: #f94144" href="https://www.zakon.hr/z/257/Zakon-o-zaštiti-životinja" target="_blank">Zakon o zaštiti životinja</a></p>
    
     <div style="margin-left: 15px">

      <p>
         <strong>2.1.1. Opasni psi</strong>
      </p>
      <p>
         Psi iz kontroliranog uzgoja pasmina terijera tipa bull - stafordski bull terijer, američki stafordski terijer, bull terijer i mini bull terijer - moraju posjedovati rodovnicu izdanu od Hrvatskog kinološkog saveza i biti upisani u Hrvatsku rodovnu knjigu ili posjedovati rodovnicu izdanu od kinološkog saveza jedne od zemalja članica Međunarodne kinološke organizacije (F.C.I).
      </p>
   
   
      <p>Opasnim psom smatra se:</p>
      <p><strong>a. </strong>bilo koja jedinka te vrste, podrijetlom od bilo koje pasmine koja je:
         <ul>
            <li>ničim izazvana, napala čovjeka i nanijela mu tjelesne ozljede ili ga usmrtila</li>
            <li>ničim izazvana napala drugog psa i nanijela mu teške tjelesne ozljede</li>
            <li>uzgajana i/ili dresirana za borbe pasa ili zatečena u organiziranoj borbi s drugim psom;</li>
         </ul>
      </p>
      <p><strong>b. </strong>pas pasmine terijera tipa bull, koji ne potječe iz uzgoja iz članka 8. stavka 1. Pravilnika o opasnim psima (pit bull terijer) i njegovi križanci.</p>
      <p>Pit bull nije pasmina koju priznaje HKS stoga niti ne može imati rodovnicu.</p>
      <p><a style="color: #f94144" href="https://narodne-novine.nn.hr/clanci/sluzbeni/2008_10_117_3386.html">Pravilnik o opasnim psima</a></p>
   
      <p>
         <strong>2.1.2. Zaštićene vrste</strong>
      </p>
      <p>Sve životinje označene kao strogo zaštićena vrsta u Prilogu 1. Pravilnika o strogo zaštićenim vrstama zabranjeno je držati, prevoziti, prodavati, razmjenjivati te nuditi na prodaju ili razmjenu živih ili mrtvih jedinki iz prirode - osim ako nije ishođeno dopuštenje Ministarstva zaštite okoliša i energetike. Za odstupanja ili uzgoj strogo zaštićenih vrsta potrebno ishoditi dopuštenje Ministarstva zaštite okoliša i energetike.</p>
      <p><a style="color: #f94144" href="https://narodne-novine.nn.hr/clanci/sluzbeni/2013_12_144_3086.html">Pravilnik o strogo zaštićenim vrstama</a></p>
      
     </div>
   <p>
      <br/>
      <strong>3. ALKOHOL </strong>
   </p>
   <p>Sva alkoholna pića trošarinski su proizvod te kao takvi moraju biti označeni markicom (preko čepa na boci) te posjedovati odobrenje sukladno Zakonu o trošarinama. Alkoholna pića iz privatnih kolekcija te ona koja su već puštena u potrošnju u drugoj državi također se smatraju trošarinskim proizvodom, a zabranjeno je stavljanje u promet, kupnja i prodaja proizvoda na koje nije obračunata i plaćena trošarina.
   </p>
   <p>Mošt, vino ili drugi proizvodi od grožđa i vina te voćnih vina u prometu moraju biti označeni sukladno Zakonu o vinu i propisima donesenim na temelju njega, što kontroliraju Vinarski inspektori.</p>
   <p>Objavljivanje prodaje alkohola i alkoholnih pića protivno je odredbama Zakona o trošarinama. Oglašavanje alkoholnih pića nije dopušteno na Index Oglasima.</p>

   <p><a style="color: #f94144" href="https://www.zakon.hr/z/545/Zakon-o-trošarinama">Zakon o trošarinama</a></p>
   <p><a style="color: #f94144" href="https://narodne-novine.nn.hr/clanci/sluzbeni/2019_03_32_641.html">Zakonu o vinu</a></p>



   <p>
      <br/>
      <strong>4. DUHAN I DUHANSKI PROIZVODI</strong>
   </p>

   <p>Oglašavanje i promidžba jest svaki oblik komercijalne komunikacije, uključujući usluge informacijskog društva. Sponzoriranje i promoviranje jest svaki oblik doprinosa pravne ili fizičke osobe događaju, aktivnosti ili pojedincu s ciljem, učinkom ili mogućim učinkom izravne ili neizravne promidžbe duhanskih i srodnih proizvoda te pušenja ili uporabe duhana.</p>
   <p>Zabranjena je izravna i neizravna promidžba i oglašavanje duhanskih i srodnih proizvoda (e-cigareta, tekućina), oglašavanje i promidžba proizvoda koji se ne smatraju duhanskim i srodnim proizvodom, a koji svojim oblikom, nazivom ili namjenom neposredno potiču potrošnju tih proizvoda te svako drugo oglašavanje koje oblikom, nazivom ili namjenom potiče potrošnju takvih proizvoda.</p>
   <p>Oglašavanje duhanskih i srodnih proizvoda nije dozvoljeno na Index Oglasima.</p>
   <p><a style="color: #f94144" href="https://www.zakon.hr/z/909/Zakon-o-ograničavanju-uporabe-duhanskih-i-srodnih-proizvoda">Zakon o ograničavanju uporabe duhanskih i srodnih proizvoda</a></p>

   <p>
      <br/>
      <strong>5. LIJEKOVI</strong>
   </p>
   <p>Fizičke i pravne osobe koje obavljaju ljekarničku djelatnost u Republici Hrvatskoj mogu putem interneta nuditi za prodaju na daljinu, sukladno posebnom propisu, lijekove koji se izdaju bez recepta.</p>
   <p>S obzirom na način izdavanja lijekovi se razvrstavaju na:</p>
   <ul>
      <li>lijekove koji se izdaju na recept</li>
      <li>lijekove koji se izdaju bez recepta.</li>
   </ul>
   <p>S obzirom na mjesto izdavanja lijekovi se razvrstavaju u sljedeće skupine:</p>
   <ul>
      <li>lijekovi koji se izdaju na recept u ljekarni</li>
      <li>lijekovi koji se izdaju bez recepta u ljekarni</li>
      <li>lijekovi koji se izdaju bez recepta u ljekarni i specijaliziranim prodavaonicama za promet na malo lijekovima.</li>
   </ul>
   <p>Dodatak prehrani:</p>
   <ul>
      <li>prehrambeni proizvod</li>
      <li>ne služi liječenju već samo pomaže u održavanju zdravlja</li>
      <li>registar dodataka prehrani nije javno dostupan</li>
      <li>dozvoljeno je oglašavati.</li>
   </ul>
   <p>Nije dozvoljeno oglašavati lijekove na Index Oglasima, već samo dodatke prehrani.</p>
   <p><a style="color: #f94144" href="https://www.zakon.hr/z/399/Zakon-o-lijekovima">Zakon o lijekovima</a></p>

   <p>
      <br/>
      <strong>6. PESTICIDI I HERBICIDI</strong>
   </p>
   <p>Za prodaju pesticida i herbicida potrebno je imati dozvolu Ministarstva poljoprivrede. Kako nismo u mogućnosti provjeravati koji korisnik zaista ima dozvolu, na Index Oglasima nije dozvoljeno oglašavanje pesticida i herbicida.</p>
   <p><a style="color: #f94144" href="https://www.zakon.hr/z/703/Zakon-o-održivoj-uporabi-pesticida">Zakon o održivoj uporabi pesticida</a></p>

   <p>
      <br/>
      <strong>7. UREĐAJI ZA NADZOR</strong>
   </p>
   <p>Prema Zakonu o elektroničkim komunikacijama zabranjeno je slušanje, prisluškivanje, pohranjivanje te svaki oblik presretanja ili nadzora elektroničkih i pripadajućih prometnih podataka.</p>

   <p>
      <br/>
      <strong>8. UREĐAJI ZA OMETANJE RADARA</strong>
   </p>
   <p>Ne postoji zakon, uredba ili propis koji određuju da se uređaji kojima je cilj ometanje/otkrivanje uređaja koje koriste osobe ovlaštene za nadzor prometa ne smiju oglašavati, ili čak prodavati, već samo da se ne smiju ugrađivati. Oglašavanje svih takvih proizvoda je dopušteno.</p>
   <p><a style="color: #f94144" href="https://www.zakon.hr/z/182/Zakon-o-elektroničkim-komunikacijama">Zakon o elektroničkim komunikacijama</a></p>

   <p>
      <br/>
      <strong>9. BROJEVI S POSEBNOM NAPLATOM (060)</strong>
   </p>
   <p>Usluga mora biti detaljno opisana te mora sadržavati cijenu i način naplate usluge tako da je opis usluge čitljiv i lako razumljiv korisniku. Potrebno je jasno naznačiti naplaćuje li se korištenje usluge s posebnom tarifom po pozivu, po duljini trajanja razgovora ili po količini prometa.</p>
   <p>Mora biti jasno vidljivo:</p>
   <ul>
      <li>cijena (uključen PDV; navesti ako je različita za pristup iz pokretne odnosno nepokretne elektroničke komunikacijske mreže)</li>
      <li>ime operatera usluga s posebnom tarifom</li>
      <li>kontakt telefonski broj (nije iz kategorije brojeva s posebnom tarifom)</li>
      <li>cijena i način naplate usluge, kao i telefonski broj, kratki kod ili adresa usluge moraju se nalaziti jedan do drugog ili jedan ispod drugog i biti napisani na isti način (font, veličina, boja, oblik, smjer itd.) na istoj boji podloge.</li>
   </ul>
   <p><a style="color: #f94144" href="https://www.zakon.hr/cms.htm?id=27631">Pravilnik o načinu i uvjetima obavljanja djelatnosti elektroničkih komunikacijskih mreža i usluga</a></p>

   <p>
      <br/>
      <strong>10. POVREDA PRAVA NA ŽIG</strong>
   </p>
   <p>Sukladno čl. 21 Zakona o elektroničkoj trgovini, dužni smo reagirati u trenutku kada nam budu dostavljeni dokazi da je riječ o kršenju zakona. Dostavljeni dokaz se smatra službeni ovjereni dopis ovlaštenog odvjetničkog društva, odnosno pravnog zastupnika pojedinog brenda. Takav dopis mora biti napisan na hrvatskom jeziku, mora biti ovjeren od strane zakonskog zastupnika te mora specificirati za svaki oglas točan razlog zbog kojeg se traži njegovo uklanjanje.</p>
   <p>Čl. 11. Zakona o žigu daje pravo nositelju žiga zabraniti njegovo korištenje u oglašavanju. U smislu st. 2. istog članka, nositelj žig može zabraniti i sljedeće:</p>
   <ul>
      <li>isticanje znaka na proizvodima ili njihovim pakiranjima</li>
      <li>nuđenje proizvoda, ili njihovo stavljanje na tržište ili skladištenje u te svrhe pod tim znakom, ili nuđenje ili pružanje usluga pod tim znakom</li>
      <li>uvoz ili izvoz proizvoda obilježenih tim znakom</li>
      <li>uporabu znaka na poslovnim dokumentima i u reklamiranju.</li>
   </ul>
   <p><a style="color: #f94144" href="https://eur-lex.europa.eu/legal-content/hr/TXT/?uri=CELEX%3A32017R1001" target="_blank">Uredba EU parlamenta i Vijeća o žigu EU</a></p>
   <p><a style="color: #f94144" href="https://www.zakon.hr/z/120/Zakon-o-žigu" target="_blank">Zakon o žigu</a></p>
   <p><a style="color: #f94144" href="https://www.zakon.hr/z/175/Zakon-o-trgovini" target="_blank">Zakon o trgovini</a></p>
   <p><a style="color: #f94144" href="https://www.zakon.hr/z/98/Kazneni-zakon" target="_blank">Kazneni zakon</a></p>


   <p>
      <br/>
      <strong>11. IDEOLOŠKA OBILJEŽJA</strong>
   </p>
   <p>Prema čl. 325. Kaznenog zakona, zabranjeno je javno poticanje na nasilje i mržnju: “Tko putem tiska, radija, televizije, računalnog sustava ili mreže, na javnom skupu ili na drugi način javno potiče ili javnosti učini dostupnim letke, slike ili druge materijale kojima se poziva na nasilje ili mržnju usmjerenu prema skupini ljudi ili pripadniku skupine zbog njihove rasne, vjerske, nacionalne ili etničke pripadnosti, podrijetla, boje kože, spola, spolnog opredjeljenja, rodnog identiteta, invaliditeta ili kakvih drugih osobina, kaznit će se kaznom zatvora do tri godine.”</p>
   <p>Dozvoljeno je objaviti oglase ako se u njemu oglašavaju predmeti koji imaju povijesnu ili umjetničku vrijednost, ili imaju sadržaj koji govori o određenim režimima. To se odnosi na sve oglase za poštanske marke, kovanice, medalje, značke, zastave, odore, kape, knjige, dokumente, stare postere i slično, koji imaju nacistička, fašistička i obilježja drugih totalitarnih režima.</p>
   <p>Nije dozvoljeno objaviti oglase koji sadrže predmete koji nemaju povijesnu vrijednost. To se odnosi na, primjerice, majicu sa svastikom i drugim obilježjima totalitarnih režima, licima osoba koje su povezane s totalitarnim režimima, povicima totalitarnih režima i slično.</p>
   <p><a style="color: #f94144" href="https://www.zakon.hr/z/98/Kazneni-zakon" target="_blank">Kazneni zakon</a></p>
   <p><a style="color: #f94144" href="https://www.zakon.hr/z/279/Zakon-o-prekršajima-protiv-javnog-reda-i-mira" target="_blank">Zakon o prekršajima protiv javnog reda i mira</a></p>
   <p><a style="color: #f94144" href="https://www.zakon.hr/z/490/Zakon-o-suzbijanju-diskriminacije" target="_blank">Zakon o suzbijanju diskriminacije</a></p>
   
   <p>
      <br/>
      <strong>12. OGLAŠAVANJE VATRENOG ORUŽJA</strong>
   </p>
   <p>Pravila za oglašavanje oružja:</p>
   <p>
      <ol>
         <li>Oglašavanje je dozvoljeno isključivo:</li>
          <ul>
            <li>pravnim osobama i obrtnicima s važećim odobrenjem Ministarstva unutarnjih poslova RH za promet oružjem,</li>
            <li>fizičkim osobama koje imaju valjanu dozvolu za posjedovanje oružja kategorije B ili C.</li>
         </ul>
         <li>Kupnja i prodaja vatrenog oružja moguća je isključivo uz predočenje valjanog oružnog lista ili odobrenja za nabavu oružja.</li>
         <li>Oružje se ne smije slati poštom. Predaja se vrši isključivo osobno, uz provjeru identiteta i dokumentacije.</li>
         <li>Oglasi koji promoviraju nasilje ili nisu u skladu sa zakonom bit će uklonjeni bez prethodne najave.</li>
         <li>Oglašivač je odgovoran za točnost podataka u oglasu i za zakonitost ponude.</li>
         <li>Oglašavanje nije dozvoljeno maloljetnim osobama.</li>
      </ol>
   </p>

   <p>
      <br/>
      <strong>13. PIROTEHNIKA</strong>
   </p>
   <p>Pravne osobe i obrti mogu prodavati oružje, streljivo i dijelove streljiva (barut, kapisle i kapislirane čahure) na malo u prodavaonicama oružja i streljiva, a pirotehnička sredstva kategorije F2, F3, P1 i T1, osim petardi i redenika iz kategorije F3, čija je prodaja građanima zabranjena, u prodavaonicama pirotehničkih sredstava za koje posjeduju odobrenje Ministarstva. Osobe koje obavljaju prodaju u navedenim prodavaonicama moraju biti stručno osposobljene i zdravstveno sposobne.</p>
   <p>Pirotehnička sredstva mogu se prodavati od 15. prosinca do 1. siječnja, i to u samo specijaliziranim trgovinama, a smije ih se koristiti od 27. prosinca do 1. siječnja te njihova prodaja na Index Oglasima nije dozvoljena.</p>
   <p><a style="color: #f94144" href="https://www.zakon.hr/z/931/Zakon-o-eksplozivnim-tvarima-te-proizvodnji-i-prometu-oružja">Zakon o eksplozivnim tvarima te proizvodnji i prometu oružja</a></p>
   <p><a style="color: #f94144" href="https://eur-lex.europa.eu/legal-content/HR/TXT/?uri=CELEX:32019R1148">Zakon o provedbi Uredbe (EU) 2019/1148 EUROPSKOG PARLAMENTA I VIJEĆA od 20. lipnja 2019. o stavljanju na tržište i uporabi prekursora eksploziva te izmjeni Uredbe (EZ) br. 1907/2006</a></p>
   

   <p>
      <br/>
      <strong>14. PREKURSORI EKSPLOZIVA</strong>
   </p>
   <p>Zakon o provedbi Uredbe (EU) 2019/1148 EUROPSKOG PARLAMENTA I VIJEĆA od 20. lipnja 2019. o stavljanju na tržište i uporabi prekursora eksploziva te izmjeni Uredbe (EZ) br. 1907/2006.</p>

   <p><strong>OBVEZE INTERNETSKOG TRŽIŠTA (čl. 6.)</strong><br></p>
   <p>Internetsko tržište poduzima mjere i koristi alate kako bi osiguralo da korisnici koji stavljaju na raspolaganje regulirane prekursore eksploziva pomoću njegovih usluga posredovanja budu obaviješteni o svojim obvezama iz Uredbe (EU) 2019/1148.</p>
   <p>Internetsko tržište mora imati opciju prijave sumnjivih transakcija kako bi korisnici koji stavljaju na raspolaganje regulirane prekursore eksploziva pomoću njegovih usluga mogli postupiti u skladu s člankom 9. Uredbe (EU) 2019/1148.</p>

   <p><strong>OGRANIČENI PREKURSORI EKSPLOZIVA</strong><br></p>
   <p>Popis stvari koje se ne stavljaju na raspolaganje pojedinačnim korisnicima, niti ih pojedinačni korisnici uvode, posjeduju ili upotrebljavaju kao takve ili u smjesama ili tvarima koje sadržavaju te tvari, osim ako je njihova koncentracija jednaka ili niža od graničnih vrijednosti utvrđenih u stupcu 2., i u vezi s kojima se sumnjive transakcije te znatni nestanci i krađe trebaju prijaviti u roku od 24 sata, dostupan je u Uredbi: Uredba (EU) 2019/1148 EUROPSKOG PARLAMENTA I VIJEĆA od 20. lipnja 2019. o stavljanju na tržište i uporabi prekursora eksploziva te izmjeni Uredbe (EZ) br. 1907/2006.</p>

   <p><strong>PREKURSORI EKSPLOZIVA KOJE TREBA PRIJAVITI</strong><br></p>
   <p>Popis tvari kao takvih ili u smjesama ili u tvarima za koje se sumnjive transakcije te znatni nestanci i krađe trebaju prijaviti u roku od 24 sata, također je dostupan u Uredbi: Uredba (EU) 2019/1148 Europskog parlamenta i Vijeća od 20. lipnja 2019. o stavljanju na tržište i uporabi prekursora eksploziva te izmjeni Uredbe (EZ) br. 1907/2006.</p>
   <p><a style="color: #f94144" href="https://eur-lex.europa.eu/legal-content/HR/TXT/?uri=CELEX:32019R1148">Uredba (EU) 2019/1148 EUROPSKOG PARLAMENTA I VIJEĆA od 20. lipnja 2019. o stavljanju na tržište i uporabi prekursora eksploziva te izmjeni Uredbe (EZ) br. 1907/2006.</a></p>
   
  </div>

`;

const InstructionsForUse = () => (
   <div className={styles.container}>
      <HelmetComponent
         title={`${"Pravila za predaju oglasa"} | ${"INDEX OGLASI"}`}
      />
      <div className={styles.title}>{"Pravila za predaju oglasa"}</div>
      <StaticHTML content={instructionsForUse} />
   </div>
);

export default InstructionsForUse;



// WEBPACK FOOTER //
// ./src/components/Help/InstructionsForUse/InstructionsForUse.tsx